import { CheckboxButton } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as React from 'react';

import style from './index.css';

export interface IHeaderProps {
  includeNewMoscow: boolean | null;
  isRedesign?: boolean;
  onNewMoscowSwitched(includeNewMoscow: boolean | null): void;
}

export class MoscowDistrictsHeader extends React.Component<IHeaderProps> {
  public render() {
    return (
      <div className={clsx(this.props.isRedesign ? style['header-redesign'] : style.header)}>
        <CheckboxButton
          label="Новая Москва"
          checked={this.props.includeNewMoscow === null ? false : this.props.includeNewMoscow}
          onChange={() => {
            this.props.onNewMoscowSwitched(this.props.includeNewMoscow ? null : true);
          }}
        />

        <CheckboxButton
          label="Москва без Новой Москвы"
          onChange={() => {
            this.props.onNewMoscowSwitched(
              this.props.includeNewMoscow === undefined
                ? false
                : this.checkWithoutNewMoscow(!!this.props.includeNewMoscow),
            );
          }}
          checked={this.props.includeNewMoscow === null ? false : !this.props.includeNewMoscow}
        />
      </div>
    );
  }

  private checkWithoutNewMoscow = (includeNewMoscow: boolean) => {
    return includeNewMoscow ? false : null;
  };
}
